// useFriendMutations.js
// Hooks personalizados para mutaciones relacionadas con amigos usando TanStack Query.
// Maneja acciones como bloquear usuario o enviar like.
// Adaptado para web desde amarsi-app.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { blockUser, manageInteraction } from '../services/friendService';

// Hook para bloquear a un usuario.
// Usa useMutation para insertar en 'unlinked'.
// Invalida consultas relacionadas si es exitoso.
export const useBlockUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ gestorId, bloqueadoId }) => blockUser(gestorId, bloqueadoId),
    onSuccess: () => {
      // Invalidar consultas de amigos o interacciones si es necesario
      queryClient.invalidateQueries({ queryKey: ['friendProfile'] });
    },
  });
};

// Hook para enviar un like o visita.
// Usa useMutation para llamar a manageInteraction.
// Invalida interacciones después del éxito.
export const useLikeUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params) => manageInteraction(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['friendInteractions'] });
    },
  });
};
